module.exports = __webpack_public_path__ + "dfccae90e90bdda421311a23c6c681e4.wav";